import { render, staticRenderFns } from "./home_video.vue?vue&type=template&id=d172b8b8&scoped=true"
import script from "./home_video.vue?vue&type=script&lang=js"
export * from "./home_video.vue?vue&type=script&lang=js"
import style0 from "./home_video.vue?vue&type=style&index=0&id=d172b8b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d172b8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d172b8b8')) {
      api.createRecord('d172b8b8', component.options)
    } else {
      api.reload('d172b8b8', component.options)
    }
    module.hot.accept("./home_video.vue?vue&type=template&id=d172b8b8&scoped=true", function () {
      api.rerender('d172b8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_video.vue"
export default component.exports